import { Button } from '@mui/material';
import { FC, useState } from 'react';
import type { Dayjs } from 'dayjs';
import { Roles } from '@callmart/types';
import { ReactComponent as FileExport } from '../../assets/file-export.svg';
import ExportTotalsDialog from './ExportTotalsDialog';

interface ExportTotalsButtonProps {
    date: Dayjs;
    location?: string | number;
    exportButtonType: Roles.CallmartTEF | Roles.CallmartOSP;
}

const ExportTotalsButton: FC<ExportTotalsButtonProps> = ({ date, location, exportButtonType }) => {
    const [showExportTotalsDialog, setShowExportTotalsDialog] = useState(false);

    return (
        <>
            <Button onClick={() => setShowExportTotalsDialog(true)} variant="contained">
                <FileExport />
            </Button>
            {showExportTotalsDialog && (
                <ExportTotalsDialog
                    open={showExportTotalsDialog}
                    onClose={() => setShowExportTotalsDialog(false)}
                    date={date}
                    location={location}
                    exportButtonType={exportButtonType}
                ></ExportTotalsDialog>
            )}
        </>
    );
};

export default ExportTotalsButton;
